import React from 'react';
import PropTypes from 'prop-types';
import NeuroMessage from '../NeuroMessage';
import getLogger from '@ignitesales/logger-es';
import classnames from 'classnames';
import { FormProvider, useForm } from 'react-hook-form';

const logger = getLogger({ module: 'FormContainer' });

const FormContainer = ({
  children,
  className,
  formId,
  onChange,
  onSubmit,
  renderDefaultSubmit
}) => {
  const useFormHookMethods = useForm();
  const { handleSubmit, getValues } = useFormHookMethods;
  const componentClass = 'neuroForm';
  const classes = classnames(className, componentClass);

  const onSubmitFn = data => {
    logger.debug(`Submitted form for ID: ${formId}`, data);
    onSubmit && onSubmit(data);
  };

  const onChangeFn = () => {
    const values = getValues();
    onChange && onChange(values);
  };

  return <FormProvider {...useFormHookMethods}>
    <form className={classes} onSubmit={handleSubmit(onSubmitFn)} onChange={onChangeFn}>
      <div className={`${componentClass}__body`}>
        { children }
      </div>
      {renderDefaultSubmit && <div className={`${componentClass}__actions`}>
        <button type="submit" className="btn btn-primary">
          <NeuroMessage id="form.submit"/>
        </button>
      </div>
      }
    </form>
  </FormProvider>;
};
FormContainer.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  formId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  renderDefaultSubmit: PropTypes.bool
};

export default FormContainer;
